import { Link } from "react-router-dom";
import { CalendarCheck, MapPin, CreditCard, Truck, ArrowRight } from "lucide-react";

const STEPS = [
  { icon: CalendarCheck, title: "Pick your plan", text: "Monthly, Quarterly, or a One-Time Deep Clean. Add extra bins if you've got more than one." },
  { icon: MapPin, title: "Grab a real slot", text: "Choose an open Mon–Thu window, 10am–8pm. We cap each slot so we never overbook your day." },
  { icon: CreditCard, title: "Enter details & pay", text: "Tell us your address, ZIP and pickup day. Pay securely with Stripe — recurring plans save your card." },
  { icon: Truck, title: "We clean & renew", text: "We show up, blast & sanitize your bins, mark it done, and auto-rebill on schedule. Cancel after your minimum." },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page" className="pb-24">
      <div className="mx-auto max-w-3xl px-5 pt-20 text-center lg:px-8">
        <p className="text-sm font-semibold uppercase tracking-wider text-primary">How It Works</p>
        <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tighter md:text-5xl">
          Fresh bins in four easy steps
        </h1>
        <p className="mt-5 text-lg text-muted-foreground">
          The whole booking takes about a minute. Here's exactly what happens.
        </p>
      </div>
      <div className="mx-auto mt-16 max-w-5xl px-5 lg:px-8">
        <div className="grid gap-6 md:grid-cols-2">
          {STEPS.map((s, i) => (
            <div key={s.title} className="relative rounded-2xl border border-border bg-card p-8 transition-all hover:shadow-lg">
              <span className="absolute right-6 top-6 font-heading text-5xl font-extrabold text-accent">
                {i + 1}
              </span>
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                <s.icon className="h-6 w-6" />
              </span>
              <h3 className="mt-5 font-heading text-xl font-bold">{s.title}</h3>
              <p className="mt-2 text-muted-foreground">{s.text}</p>
            </div>
          ))}
        </div>
        <div className="mt-14 rounded-2xl bg-gradient-to-br from-primary via-primary/80 to-[#0D1B2A] px-8 py-12 text-center ring-1 ring-secondary/30">
          <h3 className="font-heading text-2xl font-bold text-white">Recurring, but never a trap</h3>
          <p className="mx-auto mt-3 max-w-xl text-white/85">
            Monthly and Quarterly plans renew automatically on their schedule. After your
            plan minimum (3 visits monthly, 2 quarterly), you can pause or cancel anytime
            through your secure Stripe portal — no phone calls, no hassle.
          </p>
          <Link to="/booking" className="mt-7 inline-flex items-center gap-2 rounded-xl bg-secondary px-7 py-3.5 font-extrabold text-secondary-foreground shadow-[0_0_20px_rgba(57,255,20,0.3)] transition-all hover:-translate-y-0.5 hover:brightness-110">
            Start Booking <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </div>
  );
}
